var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-sheet',{attrs:{"justify-center":"","align-center":"","outlined":"","color":"transparent"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }